import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.css']
})
export class NotfoundComponent implements OnInit {
  //Passed parameters
  @Input() SeachValue: string;
  constructor() { }

  ngOnInit(): void {

    // handle multiple values
    if (!this.SeachValue)
    {
      this.SeachValue = "specified terms";
    }else{
      this.SeachValue = "\""+ this.SeachValue +"\""
    }
  }

}
